import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsOzMall extends Vue {
  get isOzMall(): true {
    return true;
  }
}
